import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import Supplier, { newSupplier } from "../../models/supplier";
import SupplierForm from "./SupplierForm";

interface SupplierUpdateModalProps {
  show: boolean;
  supplier?: Supplier;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const SupplierUpdateModal: React.FC<SupplierUpdateModalProps> = ({
  show,
  supplier,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialSupplier, setInitialSupplier] = useState<Supplier>(
    supplier ? supplier : newSupplier()
  );

  const modalTitle = supplier
    ? `Editar proveedor: ${supplier.legalName} - ${supplier.ruc}`
    : `Crear proveedor nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialSupplier(newSupplier());
    onCancel();
  };
  useEffect(() => {
    setInitialSupplier(supplier ? supplier : newSupplier());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supplier]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <SupplierForm
            initialSupplier={initialSupplier}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default SupplierUpdateModal;
